import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { PATH_PREFIX } from 'routes/routes';

export interface IStatus {
  found: boolean;
  status: 0 | 1;
  record_date: string;
  show_banner: boolean;
}
export interface ISendStats {
  msisdn: number;
  accepted?: boolean;
  timestamp: number;
}

export const statApi = createApi({
  reducerPath: 'statApi',
  baseQuery: fetchBaseQuery(),
  tagTypes: ['Consent'],
  endpoints: ({ query, mutation }) => ({
    sendStats: mutation<string, ISendStats>({
      query: ({ msisdn, accepted, timestamp }) => ({
        url: `${PATH_PREFIX}/privacy/consent`,
        method: 'POST',
        body: {
          msisdn,
          status: accepted ? 1 : 0,
          timestamp,
        },
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: ['Consent'],
      async onQueryStarted({ msisdn, accepted }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          statApi.util.updateQueryData('checkStatus', { msisdn }, (draft) => {
            // eslint-disable-next-line no-param-reassign
            draft.status = accepted ? 1 : 0;
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    checkStatus: query<IStatus, { msisdn: number }>({
      query: ({ msisdn }) => ({
        url: `${PATH_PREFIX}/privacy/consent?msisdn=${msisdn}`,
        method: 'GET',
        headers: {
          'content-type': 'application/json',
        },
      }),
      providesTags: ['Consent'],
    }),
  }),
});
